<template>
  <div class="partners" redesign>
    <!-- Header -->
    <div class="local-hero">
      <h1 class="local-hero-header">{{ organizationDetails.programName }}</h1>
    </div>

    <div class="form-container">
      <!-- Nomination submitted message -->
      <div v-if="nomineeAdvanced" class="nominee-advanced status-message card-shape">
        <div class="success-circle-check-icon">
          <img src="@/assets/icons/success-circle-check-icon.png" />
        </div>
        <div>
          <h4>Nominee Advanced</h4>
          <p>
            Success! The nominator will be notified that their client has been advanced. Also, on January 8, 2023 the nominee will receive an e-mail invite to register.
          </p>
          </p>
        </div>
      </div>

      <!-- Nomination marked as incomplete message -->
      <div v-if="nominationIncomplete" class="nomination-incomplete status-message card-shape">
        <div class="success-circle-check-icon">
          <img src="@/assets/icons/success-circle-check-icon.png" />
        </div>
        <div>
          <h4>Nomination Marked as Incomplete</h4>
          <p>
            The nomination has been marked as incomplete & the nominator will be notified with your message.
          </p>
          </p>
        </div>
      </div>

      <!-- Nomination saved message -->
      <div v-if="nomineeDenied" class="nominee-denied status-message card-shape">
        <div class="failure-circle-x-icon">
          <img src="@/assets/icons/error-icon.png" />
        </div>
        <div>
          <h4>Nominee Denied</h4>
          <p>
            The nomination has been denied & the nominator will be notified their client will not be advancing further with the program along with your message.
          </p>
        </div>
      </div>

      
      <div class="cta-section-wrapper">
        <div class="cta-section">
          <h4 class="form-field-header">Please review the following pending nominations:</h4>
        </div>

        <!-- Nominations list container -->
        <div class="nominations cta-section card-shape">
          <LoadSpinner v-if="loading" :color="`#${organizationDetails.darkBrandColor}`" />
          <div v-if="!loading" class="nominations-list">
            <!-- Nominations list leader -->
            <div class="nominations-list-header">
              <div>Name</div>
              <div>Date Nominated</div>
              <div></div>
            </div>

            <!-- Nominations list -->
            <template v-if="nominations && nominations.length > 0">
              <div v-for="nomination in nominations" class="nomination">
                <div>{{ nomination.full_name }}</div>
                <div>{{ nomination.date }}</div>
                <div><router-link :to="nomination.id" append>View</router-link></div>
              </div>
            </template>

            <!-- No nominations -->
            <template v-else>
              <div class="form-field-container no-nominations">
                There are currently no nominations up for review.
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { LoadSpinner } from '@/components'

import NominationsApi from '@/services/nominations'

export default {
  name: 'PartnersHome',
  components: {
    LoadSpinner,
  },
  props: {
    nomineeAdvanced: {
      type: Boolean,
      default: false,
    },
    nominationIncomplete: {
      type: Boolean,
      default: false,
    },
    nomineeDenied: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      nominations: null,
    }
  },
  async mounted() {
    var nominations = await NominationsApi.list()
    this.nominations = nominations
    this.loading = false
  },
  methods: {},
  computed: {
    ...mapState(['user', 'organizationDetails', 'organizationCssVars']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.partners {
  .form-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .card-shape {
    &.status-message {
      display: flex;
      width: 60%;
    }

    &.nominee-advanced, &.nomination-incomplete {
      @extend .status-message;
      flex-direction: row;
      background-color: #e6ffd9;
    }

    &.nominee-denied {
      @extend .status-message;
      flex-direction: row;
      background-color: #faeae8;
    }

    .success-circle-check-icon, .failure-circle-x-icon {
      margin-right: 1rem;

      &.failure-circle-x-icon img {
        width: 30px;
      }
    }
  }

  .cta-section-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin: 0rem 1rem;

    .cta-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      align-self: center;
      max-width: 90%;
      justify-content: space-between;

      &:first-of-type {
        margin-top: 2.5rem;
      }

      @include desktop-screen {
        align-self: top;
      }

      h1 {
        font-size: 1.5rem;
        font-weight: bold;
        line-height: 2rem;
      }

      h4 {
        font-size: 1.25rem;
        line-height: 1.75rem;
        margin-bottom: 2rem;
      }

      h5 {
        margin-bottom: 0;

        span {
          font-weight: 500;
          font-size: 1rem;
          line-height: 1.5rem;
        }
      }
    }
  }

  .nominations {
    width: 800px;

    @include tablet-screen {
      width: 100%;
      max-width: unset !important;
    }

    .no-nominations {
      margin-top: 1rem;
    }
  }

  .add-a-nominee {
    max-width: 400px !important;
    justify-self: center;
    align-self: center;
  }

  .nominations-list {
    width: 100%;

    .nominations-list-header,
    .nomination {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0.5rem;

      &.nominations-list-header {
        border-bottom: 2px solid #dfdfe0;

        div {
          font-weight: bold;
        }
      }

      div:nth-child(1) {
        width: 30%;
      }

      div:nth-child(2) {
        width: 35%;
      }

      div:nth-child(3) {
        width: 20%;
      }
    }
  }
}
</style>
